import {
  Calendar,
  Phone,
  MapPin,
  Clock,
  Star,
  Award,
  Heart,
  Shield,
  Building2,
  Package,
  Stethoscope,
  PlusCircle,
  Baby,
  Bone,
  Brain,
  Microscope,
  ChevronRight,
  Download,
  CheckCircle,
  Trophy,
  BadgeIcon as Certificate,
  User,
  ArrowRight,
} from "lucide-react"

import { PackageCard } from "../package-card"
import { Link } from "react-router-dom"
import { Button } from "../ui/button"
import { Badge } from "../ui/badge"



export default function Healthcheckupspackageswidget() {
  return (
      <section className="py-12 bg-white">
              <div className="container px-4 mx-auto">
                <div className="flex flex-col items-center mb-10 text-center">
                  <Badge className="mb-2">Health Packages</Badge>
                  <h2 className="mb-4 text-3xl font-bold md:text-4xl">Preventive Health Checkups</h2>
                  <p className="max-w-2xl text-muted-foreground">
                    Take proactive steps towards better health with our comprehensive health checkup packages.
                  </p>
                </div>
    
                <div className="relative">
                  <div className="absolute -top-4 right-4 md:right-8 z-10">
                    <Badge className="bg-primary hover:bg-primary/90 text-white">Get 10% OFF</Badge>
                  </div>
                  <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3">
                    <PackageCard
                      title="Basic Health Checkup"
                      price="₹1,999"
                      description="Essential tests to assess your basic health parameters"
                      tests={[
                        "Complete Blood Count",
                        "Liver Function Test",
                        "Kidney Function Test",
                        "Blood Sugar",
                        "Lipid Profile",
                      ]}
                      href="/packages/basic"
                    />
                    <PackageCard
                      title="Comprehensive Health Checkup"
                      price="₹4,999"
                      description="Thorough assessment of all major health systems"
                      tests={[
                        "All Basic Tests",
                        "Thyroid Profile",
                        "Vitamin Levels",
                        "Cardiac Risk Markers",
                        "Chest X-Ray",
                        "ECG",
                      ]}
                      featured={true}
                      href="/packages/comprehensive"
                    />
                    <PackageCard
                      title="Women's Wellness Package"
                      price="₹5,999"
                      description="Specialized tests focused on women's health"
                      tests={[
                        "All Basic Tests",
                        "Thyroid Profile",
                        "Vitamin D & B12",
                        "Pap Smear",
                        "Mammography",
                        "Pelvic Ultrasound",
                      ]}
                      href="/packages/womens-wellness"
                    />
                  </div>
                </div>
    
                <div className="flex justify-center mt-8">
                  <Button className="gap-2" asChild>
                    <a
                       href="https://pranaam365.com/"
                        className="inline-flex items-center gap-1"
                      >
                        View All Health Packages
                        <ChevronRight className="w-4 h-4" />
                      </a>

                  </Button>
                </div>
              </div>
            </section>
    
  );
}

 